import { Controller } from "@hotwired/stimulus"
import { delay } from "helpers/timing_helpers"

export default class ClipboardController extends Controller {
  static targets = ["notify"]

  copy(event) {
    event.preventDefault()

    const copyLinkOriginalText = this.notifyTarget.textContent

    navigator.clipboard.writeText(event.params.text).then(() => {
      this.#onLinkCopied(copyLinkOriginalText, event.params.copiedLinkText)
    })
  }

  #onLinkCopied(
    copyLinkOriginalText,
    copiedLinkText = "Copied!",
    displayCopiedTextDurationInMs = 2000
  ) {
    this.notifyTarget.textContent = copiedLinkText

    delay(displayCopiedTextDurationInMs).then(() => {
      this.notifyTarget.textContent = copyLinkOriginalText
    })
  }
}
